import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  TrustBox,
  TrustBoxTheme,
  TrustpilotConfig,
  TrustpilotTemplateConfig,
} from '@common';
import { CONFIG } from '@config';

declare global {
  interface Window {
    Trustpilot: { loadFromElement: (args: unknown) => void } | undefined;
  }
}

@Component({
  selector: 'app-trustbox',
  templateUrl: './trustbox.component.html',
  styleUrl: './trustbox.component.scss',
})
export class TrustboxComponent implements OnInit, AfterViewInit {
  private readonly config = inject(CONFIG);

  private readonly trustpilotConfig = this.config.trustpilot;
  readonly theme = input<TrustBoxTheme>(TrustBoxTheme.Light);
  readonly trustBox: typeof TrustBox = TrustBox;
  readonly type = input<TrustBox>(TrustBox.Micro);

  businessUnitId?: string;
  fontFamily?: string;
  templateId?: string;
  textColor?: string;

  @ViewChild('trustboxElementRef') trustboxElementRef?: ElementRef;

  ngOnInit(): void {
    this.loadTrustpilotConfig();
  }

  ngAfterViewInit(): void {
    if (
      this.trustboxElementRef?.nativeElement &&
      this.templateId &&
      this.businessUnitId
    ) {
      window.Trustpilot!.loadFromElement(this.trustboxElementRef.nativeElement);
    }
  }

  private loadTrustpilotConfig(): void {
    const config: TrustpilotConfig | undefined = this.trustpilotConfig;

    this.businessUnitId = config?.businessUnitId;
    this.fontFamily = config?.fontFamily;
    this.textColor = config?.textColor;
    this.templateId = config?.templates.find(
      (template: TrustpilotTemplateConfig) => template.name === this.type(),
    )?.id;
  }
}
